import React from 'react';
import { Fade } from '@mui/material';
import { 
  PromptCard as StyledPromptCard, 
  PromptIcon, 
  PromptContent, 
  PromptTitle, 
  PromptSubtitle 
} from '../StyledComponents';
import { PromptCardProps } from '../types';

const PromptCard: React.FC<PromptCardProps> = ({
  prompt,
  onClick,
  loading,
  index
}) => {
  return (
    <Fade in={true} timeout={600 + index * 100}>
      <StyledPromptCard 
        onClick={loading ? undefined : onClick}
        sx={{
          opacity: loading ? 0.7 : 1,
          cursor: loading ? 'not-allowed' : 'pointer',
          '&:hover': {
            transform: loading ? 'none' : 'translateY(-2px)',
          }
        }}
      >
        {/* <PromptIcon>
          {prompt.icon}
        </PromptIcon> */}
        <PromptContent>
          <PromptTitle>{prompt.title}</PromptTitle>
          {/* <PromptSubtitle>{prompt.subtitle}</PromptSubtitle> */}
        </PromptContent>
      </StyledPromptCard>
    </Fade>
  );
};

export default PromptCard;
